<template>
  <MainDesktop :navbar-items>
    <template #navbar>
      <MainDesktopAddAsset />
    </template>
    <template #navbar-footer>
      <MainDesktopRepositories />
    </template>
    <template #navbar-after>
      <MainDesktopAssetTreePanel />
    </template>
    <template #content-before>
      <AppAlerts />
    </template>
    <template #content="{ isTabsVisible, isEditMode }">
      <MainDesktopTabs
        v-if="isTabsVisible"
        :disabled="isEditMode"
        :parent
        :items
      >
        <template v-if="isAddViewButtonVisible" #postfix>
          <div class="main-desktop-tabs__postfix">
            <AddViewButton>
              <template #default="{ icon, disabled, label, onClick }">
                <UIButton
                  :leading="icon"
                  :disabled
                  :label
                  size="xs"
                  variant="secondary"
                  fill="light"
                  hide-label-to-sm
                  @click="onClick"
                />
              </template>
            </AddViewButton>
          </div>
        </template>
        <template #actions>
          <LinkDataActions v-if="isLinkedDataActionsVisible" />
        </template>
      </MainDesktopTabs>
      <AppAnalyticsProgressBar class="main-desktop__progress" />
    </template>
  </MainDesktop>
</template>

<script setup lang="ts">
import { computed, ComputedRef, inject } from 'vue'

import { ADVISOR_MODE, DASHBOARD_NAME, ROUTE_NAME } from '@/const'

import { useNavigationStore } from '@/store/navigation'

import { useLocale } from '@/plugins/i18n'

import AddViewButton from '@/views/Dashboards/components/AddViewButton.vue'
import LinkDataActions from '@/modules/LinkDataActions/LinkDataActions.vue'
import MainDesktop from './Desktop/Desktop.vue'
import MainDesktopTabs from './Desktop/Tabs/Tabs.vue'
import MainDesktopAddAsset from './MainDesktopAddAsset.vue'
import MainDesktopAssetTreePanel from './MainDesktopAssetTreePanel.vue'
import MainDesktopRepositories from './MainDesktopRepositories.vue'
import { UIButton } from '@ui/buttons'
import { AppAlerts, AppAnalyticsProgressBar } from '@app'
import { BuildingLibraryIcon } from '@heroicons/vue/24/outline'

const { t } = useLocale('layouts.Main')

const navigationStore = useNavigationStore()

const isAdvisorMode = inject<ComputedRef<boolean>>(ADVISOR_MODE)

const parent = computed(() => navigationStore.getCurrentParent)

const items = computed(() => navigationStore.getCurrentChildNavigation || [])

const isLinkedDataActionsVisible = computed(() => {
  return parent.value?.label === 'Connectors'
})

const isAddViewButtonVisible = computed(() => {
  return parent.value?.label === DASHBOARD_NAME
})

const navbarItems = computed(() => [
  ...isAdvisorMode?.value ? [{
    label: t('Advisor'),
    icon: BuildingLibraryIcon,
    route: ROUTE_NAME.ADVISOR,
  }] : [],
  ...navigationStore.getParentNavigation,
])
</script>

<style scoped>
.main-desktop {
  &__progress {
    @apply -mt-5 first:mt-0 -mx-default mb-4;
  }
}

.main-desktop-tabs__postfix {
  @apply flex items-center;
}
</style>
